import { toPath } from "lodash";

const normalizePath = (path: string) => {
  //path needs to be normalized to brackets syntax, not dot notation
  //because this is the way the rest of the app searches for field errors
  const pathArray = toPath(path);
  const [firstPathNode, ...restPathNodes] = pathArray;
  const normalized = `${firstPathNode}${restPathNodes
    .map((node) => `[${node}]`)
    .join("")}`;
  return normalized;
};

export default normalizePath;
